import { GlobalDynamicVariables } from './GlobalDynamicVariables'

export enum ExternalLinks {
  FORM_ONLINE_ORDERING_WAITLIST = 'https://forms.gle/JcW6amsY23w2Qy3k8',
  SMS_SIGNUP = 'https://docs.google.com/forms/d/e/1FAIpQLSfynw5YGCZr8Hb08JZLJoUSLQG6HAk2-R4YCSgANnBs6sHGYw/viewform',
  GREENLINE_CAPITAL = 'https://getgreenline.co/greenline-capital/',
  BLAZEPAY_DASHBOARD = 'https://meetings.hubspot.com/blaze-canada/blazepay-meeting-round-robin',
  BLAZE_SITES = 'https://meetings.hubspot.com/blaze-canada/blaze-ecom-demonstration-canada?uuid=5b23a4a4-e7b2-4ad5-b07a-2b195db399dc',
}

const getHelpUrl = (greenlinePath: string, blazeposPath: string = greenlinePath) => {
  return GlobalDynamicVariables.availability.legacyKnowledgeBase()
    ? `https://help.blaze.me/can/home/${greenlinePath}`
    : `https://support.blazepos.com/${blazeposPath}`
}

export const HelpLinks = {
  get ADDING_FIRST_INVENTORY() {
    return getHelpUrl('adding-your-first-inventory-blaze-help-center')
  },
  get ADDING_INVENTORY_VIA_AUDIT() {
    return getHelpUrl('adding-inventory-via-an-audit')
  },
  get AUDITS() {
    return getHelpUrl('inventory-audits')
  },
  get BIRCHMOUNT_GIFT_CARDS() {
    return 'https://help.blaze.me/can/home/birchmount-gift-cards'
  },
  get DASHBOARD_BARCODE_VALIDATION() {
    return getHelpUrl('what-are-the-benefits', 'parked-sale-barcode-validation')
  },
  get DASHBOARD_LOG_IN() {
    return getHelpUrl('what-is-the-dashboard')
  },
  get ECOM() {
    return getHelpUrl('blaze-ecom-getting-started')
  },
  get EMPLOYEES() {
    return getHelpUrl('how-to-add-employees')
  },
  get ENDING_SHIFT() {
    return getHelpUrl('log-off-not-counting-float-1', 'log-off-not-counting-float')
  },
  get HELP_CENTER() {
    return GlobalDynamicVariables.availability.legacyKnowledgeBase()
      ? 'https://help.blaze.me/can/home'
      : 'https://support.blazepos.com'
  },
  get INTEGRATIONS() {
    return getHelpUrl('integrations')
  },
  get LEAFLY() {
    return 'https://help.blaze.me/can/home/leafly-integration'
  },
  get LOT_TRACKING() {
    return 'https://help.blaze.me/can/home/should-you-be-lot-tracking'
  },
  get LOYALTY() {
    return getHelpUrl('what-can-blaze-loyalty-do', 'greenline-loyalty')
  },
  get MAKING_FIRST_SALES() {
    return getHelpUrl('step-1')
  },
  get MERRCO_PAYSTONE_GIFT_CARDS() {
    return 'https://help.blaze.me/can/home/merrco-paystone-gift-cards'
  },
  get MERRCO_TERMINAL_SETUP() {
    return 'https://help.blaze.me/can/home/what-payment-terminals-are-supported'
  },
  get MONERIS_TERMINAL_SETUP() {
    return 'https://help.blaze.me/can/home/how-to-get-started-1'
  },
  get OUTREACH_SMS() {
    return 'https://help.blaze.me/can/home/sms-messaging'
  },
  get POS_BARCODE_VALIDATION() {
    return getHelpUrl('pos-tablet-parked-sale-barcode-validation')
  },
  get POS_HARDWARE_SETUP() {
    return getHelpUrl('pos-hardware-setup-blaze-help-center')
  },
  get PRODUCTS_ADD_EDIT() {
    return getHelpUrl('products-add-and-edit')
  },
  get PRODUCTS_ADD_FROM_DB() {
    return getHelpUrl('add-from-product-database')
  },
  get PRODUCTS_BULK_UPDATE_PRICE() {
    return 'https://help.blaze.me/can/home/how-to-export-your-product-list-for-pricing-updates'
  },
  get PRODUCTS_BRANDS_VENDORS() {
    return getHelpUrl('products-brands-vendors')
  },
  get PRODUCTS_CATEGORIES() {
    return getHelpUrl('how-to-add-product-categories')
  },
  get PRODUCTS_DISCOUNTS() {
    return getHelpUrl('products-discounts-1', 'dashboard#discounts')
  },
  get PURCHASE_ORDERS() {
    return getHelpUrl('creating-a-purchase-order')
  },
  get PURCHASE_ORDERS_IMPORT_OPTIONS() {
    return 'https://help.blaze.me/can/home/video-tutorial-resources'
  },
  get QUICKBOOKS() {
    return 'https://help.blaze.me/can/home/quickbooks-online-integration'
  },
  get REPORTS_ADVANCED() {
    return 'https://help.blaze.me/can/home/what-are-advanced-reports'
  },
  get REPORTS_COMPLIANCE() {
    return 'https://help.blaze.me/can/home/how-do-i-generate-a-compliance-report'
  },
  get REPORTS_TERMINOLOGY() {
    return getHelpUrl('reports-financial-terminology-blaze-help-center')
  },
  get SETTINGS() {
    return getHelpUrl('settings-general')
  },
  get STARTING_SHIFT() {
    return getHelpUrl('how-do-i-start-a-shift-1')
  },
  get TRANSFERS() {
    return getHelpUrl('how-to-transfer-inventory')
  },
  get WHOLESALE_COST() {
    return getHelpUrl('last-cost-default')
  },
  get WOOCOMMERCE() {
    return 'https://help.blaze.me/can/home/woocommerce-integration'
  },
  get WORLDPAY_TERMINAL_SETUP() {
    return 'https://help.blaze.me/can/home/how-do-i-get-started-with-worldpay'
  },
}
